<!-- section start -->
<section class="single-blog-head bg-webp" data-image-src="assets/images/breadcrumb" style="background-image:url('./assets/images/breadcrumb.jpg')">
    <div class="container">
        <div class="row m-t-50 m-b-0">
            <div class="col-12">
                <div class="title title2 title-inner">
                    <div class="main-title">
                        <h2 class="borders text-center color-000"><span>NCTECH iSTAR Pulsar</span></h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="agency blog-sec blog-sidebar single_blog_item">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="box-iframe">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!4v1583723729285!6m8!1m7!1sCAoSLEFGMVFpcE9YaHc0Z3R1a0toQzRIdnVjalRWalJ4d3NrV1VVRHVfTFQ4SUhk!2m2!1d35.05480437808283!2d-85.30764246920221!3f138.63!4f-0.7600000000000051!5f0.7820865974627469"></iframe>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="blog-text">
            <h3 class="blog-head text-center">Street View created with NCTECH iSTAR Pulsar</h3>
            <div class="blog-divider"></div>
            <div class="blog-description border-0 pb-0">
                <!-- TEXT HERE -->
            </div>
        </div>
    </div>
</section>
<!-- section start -->